import _ from 'underscore';

angular.module('am4').controller('userCtrl', function($scope, userData, $q, $timeout, users, $state, $stateParams, config, $translate, forgotPassword, subscriptionService, tagService, errorService, $rootScope, ngDialog) {
    var that = this;

    that.tagsFooterTemplate = require('../views/user/tagsFooter.html');
    that.subscriptionsFooterTemplate = require('../views/user/subscriptionsFooter.html');
    that.detailsFooterTemplate = require('../views/user/detailsFooter.html');

    that.user = userData;
    that.displayName = that.user.name;
    that.displayNameSaving = false;
    that.email = that.user.email;
    that.emailSaving = false;
    that.enabled = that.user.enabled;
    that.initVisibleNumberUiSelectChoices = 20;
    that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;

    $scope.$on('uiSelectInfiniteScroll:resetLimit', function() {
        that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;
    });

    that.showMoreUiSelectChoices = function() {
        that.visibleNumberUiSelectChoices += that.initVisibleNumberUiSelectChoices;
    };

    $scope.$watch(function() {
        return that.displayName;
    }, function(newVal, oldVal) {
        if (newVal && !_.isEqual(newVal, oldVal)) {
            that.displayNameSaving = true;
            users.updateName(that.user.user_id, that.displayName)
            .then(function(results) {
                that.user.display_name = results.display_name;
            })
            .catch(function(e) {
                errorService.addError('UPDATE_USER_NAME_ERROR', e);
            })
            .finally(function() {
                that.displayNameSaving = false;
            });
        } else {
            that.displayName = oldVal;
        }
    });

    $scope.$watch(function() {
        return that.email;
    }, function(newVal, oldVal) {
        if (newVal && !_.isEqual(newVal, oldVal)) {
            that.emailSaving = true;
            users.updateEmail(that.user.user_id, that.email)
            .then(function(results) {
                that.user.email = results.email;
            })
            .catch(function(e) {
                errorService.addError('UPDATE_USER_EMAIL_ERROR', e);
            })
            .finally(function() {
                that.emailSaving = false;
            });
        } else {
            that.email = oldVal;
        }
    });

    that.toggleActiveState = function() {
        that.activeStateLoading = true;
        that.activeStateSaved = false;
        that.activeStateError = false;

        that.enabled = !that.enabled;

        return users.updateActiveState(that.user.user_id, that.enabled)
        .then(function(res) {
            that.enabled = res.data.enabled;
            that.activeStateSaved = true;
        })
        .catch(function() {
            that.enabled = !that.enabled;
            that.activeStateError = true;
        })
        .finally(function() {
            that.activeStateLoading = false;
        });
    };

    that.sendPasswordReset = function() {
        that.passwordLoading = true;
        that.passwordSent = false;
        return forgotPassword.request(that.user.email)
        .then(function() {
            that.passwordSent = true;
            $timeout(function() {
                that.passwordSent = false;
            }, config.temporaryMessageTimeout);
        })
        .finally(function() {
            that.passwordLoading = false;
        });
    };

    // User Details
    that.detailsForm = {};
    that.languages = config.languages;
    that.units = config.units;
    that.availableRoles = config.userRoles.filter((role) => {
        return (role !== 'ADMINISTRATOR') || ($rootScope.userPermissions.indexOf('CREATE_ADMIN') !== -1);
    });
    that.unsavedDetailsChanges = false;
    that.showDetailsSave = false;
    that.details = {
        language: userData.language,
        unit_preference: userData.unit_preference,
        roles: userData.user_metadata.am_roles
    };
    that.detailsBackup = angular.copy(that.details);

    $scope.$watch(function() {
        return that.details;
    }, function(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal) && !_.isEqual(newVal, that.detailsBackup)) {
            that.unsavedDetailsChanges = true;
            that.showDetailsSave = true;
        } else {
            that.unsavedDetailsChanges = false;
        }
    }, true);

    that.revertDetails = function() {
        that.details = angular.copy(that.detailsBackup);
        that.unsavedDetailsChanges = false;
    };

    that.submitDetails = function() {
        that.detailsLoading = true;
        that.detailsSaved = false;
        that.detailsError = false;

        return users.updateDetails(that.user.user_id, that.details)
        .then(function() {
            that.detailsSaved = true;
            $timeout(function() {
                that.detailsSaved = false;
            }, config.temporaryMessageTimeout);
            that.unsavedDetailsChanges = false;
            that.detailsBackup = angular.copy(that.details);
            subscriptionService.getAvailableSubscriptions(that.user).then(function(availableSubscriptions) {
                that.availableSubscriptions = availableSubscriptions;
            });
        })
        .catch(function() {
            that.detailsError = true;
            that.readySend = null;
        })
        .finally(function() {
            that.detailsLoading = false;
        });
    };

    that.filterRoles = function(searchQuery) {
        return function(role) {
            if (!searchQuery) {
                return true;
            }

            return $translate.instant(role.toUpperCase()).toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
        };
    };

    // User Subscriptions
    that.subscriptionsForm = {};

    that.subscriptions = [];
    that.subscriptionsLoaded = false;
    that.newSubscriptions = [];
    that.availableSubscriptions = null;
    that.showSubscriptionsSave = false;
    that.unsavedSubscriptionsChanges = false;

    subscriptionService.getAvailableSubscriptions(that.user).then(function(availableSubscriptions) {
        that.availableSubscriptions = availableSubscriptions;
    });

    subscriptionService.getUserSubscriptions(that.user.user_id)
    .then(function(subscriptions) {
        return subscriptionService.formatWithNames(subscriptions);
    })
    .then(function(subscriptions) {
        that.subscriptions = subscriptions;
        that.subscriptionsBackup = angular.copy(that.subscriptions);
    })
    .finally(function() {
        that.subscriptionsLoaded = true;
        $scope.$watch(function() {
            return that.newSubscriptions;
        }, function(newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                that.unsavedSubscriptionsChanges = true;
                that.showSubscriptionsSave = true;
            }
        }, true);
    });

    that.addSubscription = function() {
        that.newSubscriptions.push(
            {
                type: 'organization',
                fac_org_id: ''
            }
        );
    };

    that.removeNewSubscription = function(index) {
        that.newSubscriptions.splice(index,1);
    };

    that.unsubscribe = function(id) {
        var index = _.findIndex(that.subscriptions, function(sub) {
            return sub.id === id;
        });
        that.subscriptions.splice(index,1);
        that.unsavedSubscriptionsChanges = true;
        that.showSubscriptionsSave = true;
    };

    that.revertSubscriptions = function() {
        that.subscriptions = angular.copy(that.subscriptionsBackup);
        that.newSubscriptions = [];
        that.unsavedSubscriptionsChanges = false;
    };

    that.submitSubscriptions = function() {
        that.subscriptionsLoading = true;
        that.subscriptionsSaved = false;
        that.subscriptionsError = false;

        // Prepare data for server
        _.each(that.newSubscriptions, function(newSubscription) {
            if (newSubscription.type === 'facility') {
                newSubscription.facility_id = newSubscription.fac_org_id;
            } else {
                newSubscription.organization_id = newSubscription.fac_org_id;
            }
        });

        var fullCollection = angular.copy(that.subscriptions),
            readySend;

        fullCollection = fullCollection.concat(that.newSubscriptions);
        readySend = _.map(fullCollection, function(subscription) {

            if (subscription.facility_id) {
                return {
                    facility_id: parseInt(subscription.facility_id, 10)
                };
            }

            if (subscription.organization_id) {
                return {
                    organization_id: parseInt(subscription.organization_id, 10)
                };
            }
        });

        return subscriptionService.updateUserSubscriptions(that.user.user_id, readySend)
        .then(function(data) {
            return subscriptionService.formatWithNames(data);
        })
        .then(function(subscriptions) {
            that.subscriptions = subscriptions;
            that.newSubscriptions = [];
            that.subscriptionsSaved = true;
            $timeout(function() {
                that.subscriptionsSaved = false;
            }, config.temporaryMessageTimeout);
            $timeout(function() {
                that.unsavedSubscriptionsChanges = false;
            });
            that.subscriptionsBackup = angular.copy(that.subscriptions);
        })
        .catch(function(e) {
            that.subscriptionsError = true;
            errorService.addError('UPDATE_SUBSCRIPTIONS_ERROR', e);
        })
        .finally(function() {
            that.subscriptionsLoading = false;
        });
    };

    // User Tags
    that.tagsForm = {};
    that.tags = [];
    that.tagsLoaded = false;
    that.availableTags = null;
    that.newTags = [];
    that.showTagsSave = false;
    that.unsavedTagsChanges = false;
    that.newCopiedTags = [];

    let tagPromises = [];
    tagPromises.push(tagService.getAvailableTags());
    tagPromises.push(tagService.getUserTags(that.user.user_id));

    $q.all([
        tagService.getAvailableTags(),
        tagService.getUserTags(that.user.user_id)
    ]).then(results => {
        that.availableTags = results[0];
        that.tagsBackup = angular.copy(results[1]);
        that.tags = fixTagNames(results[1], that.availableTags);
    })
    .finally(function() {
        that.tagsLoaded = true;

        $scope.$watch(function() {
            return that.newTags;
        }, function(newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                that.unsavedTagsChanges = true;
                that.showTagsSave = true;
            }
        }, true);
    });

    that.addTag = function() {
        that.newTags.push(
            {
                type: 'organization',
                tag_id: '',
                name: ''
            }
        );
    };

    that.openCopyTagModal = function() {
        const dialog = ngDialog.open({
            template: require('../views/modal/copyTag.html'),
            plain: true,
            controller: ['$scope', 'ngDialog', function($scope, ngDialog) {
                var id = ngDialog.getOpenDialogs()[0];
                $scope.copyUserSearch = '';
                $scope.userToCopy = null;
                $scope.copyableUsers = [];
                $scope.resultsLoaded = false;

                $scope.$watch('copyUserSearch',
                    _.debounce(function(search) {
                        users.query({
                            search: search
                        }).then((res) => {
                            $scope.copyableUsers = res.data;
                            if ($scope.copyUserSearch) {
                                $scope.resultsLoaded = true;
                            } else {
                                $scope.resultsLoaded = false;
                            }
                        });
                    }, 250)
                );

                $scope.selectUser = (id) => {
                    $scope.userToCopy = id;
                };

                $scope.submit = () => {
                    tagService.getUserTags(`auth0|asset_management_${$scope.userToCopy}`)
                    .then(res => {
                        ngDialog.close(id, { userTags: res });
                    })
                    .catch(() => {
                        ngDialog.close(id, { userTags: [] });
                    });
                };
            }]
        });

        dialog.closePromise.then((data) => {
            that.newCopiedTags = fixTagNames(data.value.userTags, that.availableTags)
                .map((t) => {
                    return {
                        type: t.tag_type,
                        tag_id: t.tag_id,
                        name: t.tag_name
                    };
                });
            that.unsavedTagsChanges = true;
            that.showTagsSave = true;
        });
    };

    that.removeTag = function(id) {
        var index = _.findIndex(that.tags, function(tag) {
            return tag.tag_id === id;
        });
        that.tags.splice(index,1);
        that.unsavedTagsChanges = true;
        that.showTagsSave = true;
    };

    that.removeNewTag = function(index) {
        that.newTags.splice(index,1);
        that.unsavedTagsChanges = true;
        that.showTagsSave = true;
    };

    that.removeCopyTag = function(index) {
        that.newCopiedTags.splice(index, 1);
    };

    that.revertTags = function() {
        that.tags = angular.copy(that.tagsBackup);
        that.newTags = [];
        that.unsavedTagsChanges = false;
    };

    that.submitTags = function() {
        that.tagsLoading = true;
        that.subscriptionsLoading = true;
        that.tagsSaved = false;
        that.tagsError = false;

        // Prepare simple array of tag IDs
        var readySend = angular.copy(that.tags);
        readySend = readySend.concat(that.newTags, that.newCopiedTags);
        readySend = _.map(readySend, function(tag) {
            return tag.tag_id;
        });
        readySend = {
            tags: readySend
        };

        return tagService.updateUserTags(that.user.user_id, readySend)
        .then(function(data) {
            that.tags = fixTagNames(data.tags, that.availableTags);
            that.newTags = [];
            that.tagsSaved = true;
            that.newCopiedTags = [];
            $timeout(function() {
                that.tagsSaved = false;
            }, config.temporaryMessageTimeout);
            that.unsavedTagsChanges = false;
            that.tagsBackup = angular.copy(data.tags);

            // Refresh subscriptions and available subscriptions, based on new tags
            subscriptionService.formatWithNames(data.subscriptions).then(function(subscriptions) {
                that.subscriptions = subscriptions;
                that.newSubscriptions = [];
                $timeout(function() {
                    that.showSubscriptionsSave = false;
                    that.unsavedSubscriptionsChanges = false;
                });
            });

            that.availableSubscriptions = [];
            return subscriptionService.getAvailableSubscriptions(that.user);
        })
        .then(function(availableSubscriptions) {
            that.availableSubscriptions = availableSubscriptions;
        })
        .catch(function(e) {
            that.tagsError = true;
            errorService.addError('UPDATE_TAGS_ERROR', e);
            that.tags = fixTagNames(angular.copy(that.tagsBackup), that.availableTags);
        })
        .finally(function() {
            that.tagsLoading = false;
            that.subscriptionsLoading = false;
        });
    };

    /**
     * fixTagNames
     *
     * @param userTags - the tags for this user
     * @param availableTags - the full list of available tags
     * @returns the user tags array, but with the `tag_name`
     * property replaced with the `name` property of the tag
     * as it appears in the `availableTags` list
     */
    function fixTagNames(userTags, availableTags) {
        return _.map(userTags, userTag => {
            var matches = _.map(availableTags.types, type => {
                return _.findWhere(availableTags.tags[type.value], { tag_id: userTag.tag_id });
            });

            matches = _.filter(matches, item => !!item);
            if (matches.length) {
                userTag.tag_name = matches[0].name;
            }

            return userTag;
        });
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/userCtrl.js